window.__assetPrefix__ = '';